const GET_CATEGORIES = 'GET_CATEGORIES'
const GET_ACTIVITY_LIST = 'GET_ACTIVITY_LIST'
const GET_ACTIVITY_DETAIL = 'GET_ACTIVITY_DETAIL'

export { GET_CATEGORIES, GET_ACTIVITY_LIST, GET_ACTIVITY_DETAIL }
